import classNames from 'classnames';
import React, { memo } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

type Props = {
  count: number;
  onNextClick: any;
  onPrevClick: any;
  onBulletClick: (index: number) => () => void;
  activeSlide: number;
};

const AnimateSliderBullets = ({ count, activeSlide, onNextClick, onPrevClick, onBulletClick }: Props) => {
  const slidesArr = new Array(count).fill(true);

  return (
    <div className='tw:flex tw:items-center tw:justify-center tw:gap-8 tw:py-4 tw:lg:justify-start'>
      <div className='tw:hidden tw:cursor-pointer tw:lg:block' onClick={onPrevClick}>
        <BsArrowLeft size={20} />
      </div>

      <ul className='tw:mb-0 tw:flex tw:list-none tw:gap-2 tw:pl-0'>
        {slidesArr.map((_, idx) => (
          <li
            key={idx}
            onClick={onBulletClick(idx)}
            className={classNames(
              'tw:content-[" "] tw:inline-block tw:h-2 tw:w-2 tw:cursor-pointer tw:rounded-[100%] tw:border tw:border-brand-black',
              {
                'tw:bg-transparent': activeSlide !== idx,
                'tw:bg-brand-black': activeSlide === idx,
              }
            )}></li>
        ))}
      </ul>

      <div className='tw:hidden tw:cursor-pointer tw:lg:block' onClick={onNextClick}>
        <BsArrowRight size={20} />
      </div>
    </div>
  );
};

export default memo(AnimateSliderBullets);
